import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { showError } from 'actions/CommonActions';
import { getTransactionSummary, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { clearProductList } from 'actions/EntityActions';
import { checkDateRange } from 'utils/helpers';
import { reportTransactionCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class TransactionDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0,
                status: 0
            }
        }


        this.showBody = this.showBody.bind(this);
    }
    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `TransactionDetailsBeginDate`);
        this.props.formInput(date, `TransactionDetailsEndDate`);
    }

    componentWillUnmount() {
        this.props.clearProductList();
    }

    transactionSum() {
        let transactionSum = {
            ordersOpened: 0,
            totalAmout: 0,
            totalTax: 0,
            totalCompleted: 0,
            totalOpened: 0,
            totalVoid: 0,
            totalCancelled: 0,
            totalRefunded: 0,
            totalDiscount: 0
        }
        //calculate the tranc detail
        const transac = this.props.transactionDetails;
        for (var i = 0; i < transac.length; i++) {

            transactionSum.ordersOpened += transac[i]['status' == "Opened"];
            transactionSum.totalAmout += transac[i]['total'];
            transactionSum.totalTax += transac[i]['taxes'];
            transactionSum.totalDiscount += transac[i]['discount'];
            transactionSum.totalCompleted += transac[i]['soldProducts'];
            transactionSum.totalOpened += transac[i]['openedProducts'];
            transactionSum.totalVoid += transac[i]['voidedProducts'];
            transactionSum.totalCancelled += transac[i]['cancelledProducts'];
            transactionSum.totalRefunded += transac[i]['returnedProducts'];

        }
        this.setState(pState => {
            return {
                ...pState,
                transactionSum: transactionSum
            };
        });
    }

    cleanSearch = () => {
        this.props.clearFormInput(`TransactionDetailsBeginDate`);
        this.props.clearFormInput(`TransactionDetailsEndDate`);
        this.props.clearFormInput(`TransactionDetailsBranchOption`);
        this.props.clearFormInput(`TransactionDetailsStatus`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }
    getProductOptions = () => {
        return (this.props.products || []).map(item => {
            return {
                text: item.name,
                value: item.id,
                categoryId: item.categoryId
            };
        });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let status = this.props.status || 0;
        let pageNumber = 1;
        let pageSize = 999999;
        let approvalType = this.props.approvalType;
        let orderType = this.props.selectOrderType || 0;
        let productid = this.props.selectProductId || 0;
        let payment = this.props.payment || "All";

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/employeeactivity?beginDate=${beginDate}&endDate=${endDate}&status=${status}&productid=${productid}&payment=${payment}&pageNumber=${pageNumber}&pageSize=${pageSize}&approvalStatus=${approvalType}&orderType=${orderType}&branchId=${branch}`, "Order Details");
        }
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let orderType = this.props.selectOrderType || 0;
        let status = this.props.status || 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let approvalType = this.props.approvalType;
        let productid = this.props.selectProductId || 0;
        let payment = this.props.payment || "All";
        console.log(this.props.beginDate, beginDate, this.props.endDate, endDate);
        this.props.getTransactionSummary({ beginDate, endDate, branch, status, pageNumber, payment, pageSize, approvalType, productid, orderType });
        this.transactionSum();
    }

    render() {
        const totalRow = this.props.transactionDetails.length > 0 ? this.props.transactionDetails[0].totalrow : 0;

        return (
            <Grid headerContent={reportTransactionCrumb}>
                <PageHeader title={LOOKUP.report.transactionDetails.text} icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-order-details-report" />}/>
                <Header
                    paymentOptions={this.props.paymentOptions} products={this.getProductOptions()} filter={this.filter}
                    loggedBranch={this.props.loggedBranch} download={this.downloadReport} showBody={this.showBody} orderTypes={this.props.orderTypes} selectOrderType={this.props.selectOrderType}
                />
                {this.state.showBody && 
                    <React.Fragment>
                        <DateCurrentDisplay />
                        <CardSimple id="patient-list-table">
                            <Body transactionDetails={this.props.transactionDetails} beginDate={this.props.beginDate} endDate={this.props.endDate} transT={this.state.transactionSum} />
                            <Pagination
                                length={totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    </React.Fragment>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let orderTypes = [
        { text: "All", value: "all" },
        { text: "Online", value: "online" },
        { text: "In Store", value: "inStore" }
    ];

    // TODO: This has to be replaced to the state
    let paymentOptions = [
        { text: "All", value: "All" },
        { text: "Cash", value: "Cash" },
        { text: "Debit Card", value: "Debit" },
        { text: "Credit Card", value: "Credit" },
        { text: "Gift Card", value: "GiftCard" }
    ]
    return {
        brachOptions: brachOptions,
        orderTypes: orderTypes,
        transactionDetails: state.reports.transactionSummary,
        loggedBranch: state.common.branchId,
        beginDate: state.form.TransactionDetailsBeginDate,
        endDate: state.form.TransactionDetailsEndDate,
        branch: state.form.TransactionDetailsBranchOption,
        status: state.form.TransactionDetailsStatus,
        selectProductId: state.form.TransactionDetailsProductId,
        products: state.entity.productList,
        selectOrderType: state.form.TransactionDetailsOrderType,
        approvalType: state.form.TransactionDetailsApprovalType,
        paymentOptions,
        payment: state.form.TransactionDetailsPayment
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getTransactionSummary: model => dispatch(getTransactionSummary(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        clearProductList: () => dispatch(clearProductList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(TransactionDetails));
